/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const FeeCategory = {
  Ach: "ach",
  CardAcquiring: "card-acquiring",
  CardOther: "card-other",
  CardPull: "card-pull",
  CardPush: "card-push",
  MonthlyPlatform: "monthly-platform",
  NetworkPassthrough: "network-passthrough",
  Other: "other",
  Rtp: "rtp",
} as const;
export type FeeCategory = ClosedEnum<typeof FeeCategory>;

/** @internal */
export const FeeCategory$inboundSchema: z.ZodNativeEnum<typeof FeeCategory> = z
  .nativeEnum(FeeCategory);
/** @internal */
export const FeeCategory$outboundSchema: z.ZodNativeEnum<typeof FeeCategory> =
  FeeCategory$inboundSchema;
